module.exports = __webpack_public_path__ + "img/20220112_121920.69f61517.jpg";